import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WrapperComponent } from '../wrapper/wrapper.component';

@Component({
	template: `<ng-container #componentContainer></ng-container>`,
})
export class RouteWrapperComponent extends WrapperComponent implements OnInit {
	constructor(route: ActivatedRoute, componentFactoryResolver: ComponentFactoryResolver) {
		super(route, componentFactoryResolver);
	}

	ngOnInit(): void {
		this.componentType = this.route.snapshot.data['componentType'];
		super.ngOnInit();
	}
}
